<div class="form-modal" *ngIf="detailForm">
  <h1 mat-dialog-title>{{'LINE_DETAILS'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="detailForm" class="form-horizontal">
      <div class="form-group">

        <!-- Panel base -->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn1"
              (click)="collPn1 = !collPn1">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'BASE' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn1, 'fa-caret-up': !collPn1}"></i>
              </h5>
            </div>
            <div id="collPn1" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Número linha -->
                <div class="col-md-1 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LINE_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="LineNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.LineNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.LineNumber">{{ formErrors.LineNumber }}</span>
                </div>
                <!-- Código EAN -->
                <div class="col-md-3 col-sm-12 no-padding-right">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'EANCODE' | translate}}</mat-label>
                    <input matInput formControlName="StandardProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.StandardProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.StandardProductCode">{{ formErrors.StandardProductCode }}</span>
                </div>
                <!-- Descrição -->
                <div class="col-md-6 col-sm-12 no-padding-right">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DESCRIPTION' | translate}}</mat-label>
                    <input matInput formControlName="ProductDescription">
                  </mat-form-field>
                  <span *ngIf="formErrors.ProductDescription" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ProductDescription">{{ formErrors.ProductDescription }}</span>
                </div>
                <div class="col-md-2 col-sm-12" *ngIf="isMultipleOrder && !showReferencesPanel">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ORDERNUMBER' | translate}}</mat-label>
                    <input matInput formControlName="BuyersOrderNumber">
                  </mat-form-field>
                </div>
                <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
                <!-- Quantidade -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="Quantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.Quantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.Quantity">{{ formErrors.Quantity }}</span>
                </div>
                <!-- Unidade -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNIT' | translate}}</mat-label>
                    <mat-select formControlName="QuantityUOMCode">
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.QuantityUOMCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.QuantityUOMCode">{{ formErrors.QuantityUOMCode }}</span>
                </div>
                <!-- Cod. comprador -->
                <div class="col-md-2 col-sm-12" *ngIf="showBuyerProductCode">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'BUYER_CODE' | translate}}</mat-label>
                    <input matInput formControlName="BuyerProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyerProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyerProductCode">{{ formErrors.BuyerProductCode }}</span>
                </div>
                <!-- Cod. fornecedor -->
                <div class="col-md-2 col-sm-12" *ngIf="showSupplierProductCode">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'SELLER_CODE' | translate}}</mat-label>
                    <input matInput formControlName="SupplierProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.SupplierProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.SupplierProductCode">{{ formErrors.SupplierProductCode }}</span>
                </div>
                <!-- Lote -->
                <div class="col-md-2 col-sm-12" *ngIf="showBatchNumber">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LOT' | translate}}</mat-label>
                    <input matInput formControlName="BatchNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.BatchNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BatchNumber">{{ formErrors.BatchNumber }}</span>
                </div>
                <!-- Data validade -->
                <div class="col-md-2 col-sm-12" *ngIf="showBatchExpiryDate">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'VALIDITY_DATE' | translate}}</mat-label>
                    <input matInput formControlName="BatchExpiryDate"
                      class="one date-picker">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.BatchExpiryDate" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BatchExpiryDate">{{ formErrors.BatchExpiryDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel embalagens -->
        <div class="col-sm-12" *ngIf="showPackagingPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn2"
              (click)="collPn2 = !collPn2">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PACKAGES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn2, 'fa-caret-up': !collPn2}"></i>
              </h5>
            </div>
            <div id="collPn2" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Quantidade de embalagens-->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PACKAGES_QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="PackQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantity">{{ formErrors.PackQuantity }}</span>
                </div>
                <!-- Unidade -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNIT' | translate}}</mat-label>
                    <mat-select formControlName="PackQuantityUOMCode">
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantityUOMCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantityUOMCode">{{ formErrors.PackQuantityUOMCode }}</span>
                </div>
                <!-- Quantidade por embalamento -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'QUANTITY_FOR_PACKAGES' | translate}}</mat-label>
                    <input matInput formControlName="PackSize">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSize" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackSize">{{ formErrors.PackSize }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel sequência embalamento -->
        <div class="col-sm-12" *ngIf="showPackageSequencePanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn3"
              (click)="collPn3 = !collPn3">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PACKAGING_SEQUENCE' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn3, 'fa-caret-up': !collPn3}"></i>
              </h5>
            </div>
            <div id="collPn3" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Quantidade de embalagens-->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="PackSequenceQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSequenceQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackSequenceQuantity">{{ formErrors.PackSequenceQuantity }}</span>
                </div>
                <!-- Unidade -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNIT' | translate}}</mat-label>
                    <mat-select formControlName="PackSequenceQuantityUOMCode">
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSequenceQuantityUOMCode" class="field-validation-valid text-danger"
                    [translate]
                    [translateParams]="formErrorsParam.PackSequenceQuantityUOMCode">{{ formErrors.PackSequenceQuantityUOMCode }}</span>
                </div>
                <!-- Quantidade por embalamento -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>SSCC</mat-label>
                    <input matInput formControlName="PackSequenceTracingReference">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSequenceTracingReference" class="field-validation-valid text-danger"
                    [translate]
                    [translateParams]="formErrorsParam.PackSequenceTracingReference">{{formErrors.PackSequenceTracingReference }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel outras referencias -->
        <div class="col-sm-12" *ngIf="showReferencesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn4"
              (click)="collPn4 = !collPn4">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'REFERENCES' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn4, 'fa-caret-up': !collPn4}"></i>
              </h5>
            </div>
            <div id="collPn4" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Num Encomenda -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ORDERNUMBER' | translate}}</mat-label>
                    <input matInput formControlName="BuyersOrderNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyersOrderNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyersOrderNumber">{{formErrors.BuyersOrderNumber }}</span>
                </div>
                <!-- Numero serie -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class='allwidth'>
                    <mat-label>{{ 'SERIAL_NUMBER' | translate}}</mat-label>
                    <input matInput
                      formControlName='ProductSerialNumber'>
                  </mat-form-field>
                  <span *ngIf='formErrors.ProductSerialNumber' class='field-validation-valid text-danger' [translate]
                    [translateParams]="formErrorsParam.ProductSerialNumber">{{ formErrors.ProductSerialNumber }}
                  </span>
                </div>

                <!-- Outras referencias -->
                <div class="col-md-12 col-sm-12 no-padding">
                  <h6 class="padding-left-15">
                    <strong>{{ 'OTHER_REFERENCES' | translate}}&nbsp;&nbsp;</strong>
                    <button type="button" class="btn btn-sm" (click)="addOtherReference(true)"
                      *ngIf="!detailForm.disabled && isEditable">
                      <span title="{{'ADD' | translate}}">
                        <i class="fas fa-plus-square color-success backwhite"></i>
                      </span>
                    </button>
                  </h6>
                  <div class="table-responsive col-md-12 col-sm-12">
                    <div *ngIf="formErrorsOtherReferences.length>0"
                      class="validation-summary-errors text-danger col-md-6">
                      <ul>
                        <li *ngFor="let errorMessage of formErrorsOtherReferences; let i = index" [translate]
                          [translateParams]="formErrorsOtherReferencesParam[i]">{{errorMessage}}</li>
                      </ul>
                    </div>
                    <table class="table-bordered">
                      <thead>
                        <tr>
                          <th width="35%" class="text-center">{{ 'TYPE' | translate}}</th>
                          <th width="35%" class="text-center">{{ 'VALUE' | translate}}</th>
                          <th width="20%" class="text-center">{{ 'DATE' | translate}}</th>
                          <th width="10%" class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody
                        *ngIf="detailForm.controls.OtherReferences && detailForm.controls.OtherReferences.length > 0; else bodyNoResultsOtherReferences"
                        formArrayName="OtherReferences">
                        <tr *ngFor="let item of detailForm.controls.OtherReferences.controls; let i=index"
                          [formGroupName]="i">
                          <td>
                            <!-- Tipo Descritivo -->
                            <mat-form-field class="allwidth" *ngIf="!showOthersReferencesTypes">
                              <input matInput formControlName="ReferenceType">
                            </mat-form-field>
                            <!-- Lista de Tipos -->
                            <mat-form-field class="full-width" *ngIf="showOthersReferencesTypes">
                              <mat-select formControlName="ReferenceType">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let item of otherReferenceTypes" [value]="item.ItemCode">
                                  {{item.ItemName}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class='allwidth'>
                              <input matInput formControlName='ReferenceValue'>
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field class="allwidth">
                              <input matInput formControlName="ReferenceDate" class="one date-picker">
                                <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                            </mat-form-field>
                          </td>
                          <td class="text-center">
                            <button type="button" class="btn btn-sm" (click)="removeOtherReference(i)"
                              *ngIf="!detailForm.disabled && isEditable">
                              <span title="{{'BUTTON.DELETE' | translate}}">
                                <i class="far fa-trash-alt color-danger backwhite"></i>
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #bodyNoResultsOtherReferences>
                        <tbody>
                          <tr>
                            <td colspan="4" class="text-center">
                              {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>

        <!-- Panel observações -->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn5"
              (click)="collPn5 = !collPn5">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'OBSERVATIONS' | translate}}</strong>
                <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn5, 'fa-caret-up': !collPn5}"></i>
              </h5>
            </div>
            <div id="collPn5" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <input matInput formControlName="FreeText">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right" *ngIf="detailForm.enabled">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
        (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="allowEdit" type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}"
        (click)="save()" [disabled]="!detailForm.valid">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>

    <div class="full-width text-right" *ngIf="detailForm.disabled">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>

  </div>
</div>